import { jsx as o } from "react/jsx-runtime";
import { useDesignContext as s } from "../../../../../../providers/use-design-provider.mjs";
import { ArrowDownIcon as f } from "@systemeio/ui/icons";
import { twJoin as r } from "tailwind-merge";
var p = /* @__PURE__ */ ((t) => (t[t.left = 0] = "left", t[t.right = 1] = "right", t))(p || {});
const l = ({ className: t, onClick: i, variant: e }) => {
  const { isDefaultSioColor: n } = s();
  return /* @__PURE__ */ o(
    "div",
    {
      className: r(
        t,
        e === 0 ? "!left-2" : "!right-2",
        "!z-20 !h-[24px] !w-[24px] before:!content-none"
      ),
      onClick: i,
      children: /* @__PURE__ */ o(
        f,
        {
          className: r(
            "before:!display-none !flex !h-[24px] !w-[24px] justify-center",
            n ? "stroke-brand-primary" : "stroke-THEME-text-primary",
            e === 0 ? "rotate-90" : "-rotate-90"
          )
        }
      )
    }
  );
};
export {
  l as SliderArrow,
  p as SliderArrowEnum
};
